import { Suspense, lazy } from 'react'
import type { TextEditorProps } from './TextEditor'

// The Plate editor and its dependencies are the largest part of the bundle and are only
// needed when a task/description is open — load them lazily so they stay out of the
// initial app shell (faster boot / first load).
const TextEditor = lazy(() => import('./TextEditor'))

const LazyTextEditor = (props: TextEditorProps) => (
    <Suspense fallback={null}>
        <TextEditor {...props} />
    </Suspense>
)

export default LazyTextEditor
